import React from "react";
import { Input, Form } from "antd";
function AdnTextArea({
    name,
    label,
    rules,
    maxLength,
    placeholder,
    rows,
    showCount,
    textAreaValue,
    defaultValue,
    handleChange,
    autoSize = false,
    disabled = false,
}) {
    const { TextArea } = Input;
    return (
        <div>
            <Form.Item
                name={name}
                valuePropName={textAreaValue}
                label={label}
                rules={rules}
            >
                <TextArea
                    name={name}
                    value={textAreaValue}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    rows={rows}
                    showCount={showCount}
                    onChange={handleChange}
                    autoSize={autoSize}
                    disabled={disabled}
                />
            </Form.Item>
        </div>
    );
}

export default AdnTextArea;
